<ng-container
  *ngIf="{
    countries: countries$ | async,
  } as content"
>
  <form (ngSubmit)="verifyAddress()" [formGroup]="addressForm">
    <div class="row">
      <!-- Company -->
      <div class="col-12">
        <div class="form-group">
          <label>
            <span class="label-content">{{ 'addressForm.company.label' | cxTranslate }} </span>

            <input
              class="form-control"
              type="text"
              name="companyName"
              maxlength="10"
              placeholder="{{ 'addressForm.company.placeholder' | cxTranslate }}"
              formControlName="companyName"
              [maxlength]="40"
            />
            <cx-form-errors [control]="addressForm.get('companyName')"></cx-form-errors>
          </label>
        </div>
      </div>

      <!-- Country -->
      <div class="col-12 col-md-4">
        <div class="form-group">
          <countries-dropdown
            [isocode]="country?.isocode"
            [countries$]="countries$"
            (_onSelectCountry)="setCountry($event)"
            [form]="addressForm"
          ></countries-dropdown>

          <cx-form-errors [control]="addressForm.get('country')?.get('isocode')!"></cx-form-errors>
        </div>
      </div>

      <!-- State -->
      <ng-container *ngIf="regions$ | async as regions" formGroupName="region">
        <ng-container *ngIf="regions.length !== 0">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label for="isocode">
                <span class="label-content required">
                  {{ 'addressForm.state' | cxTranslate }}
                  <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
                </span>

                <ng-select
                  [inputAttrs]="{ required: 'true' }"
                  class="region-select"
                  formControlName="isocode"
                  [searchable]="true"
                  [clearable]="false"
                  [items]="regions"
                  bindLabel="{{ regions[0].name ? 'name' : 'isocode' }}"
                  bindValue="{{ regions[0].name ? 'isocode' : 'region' }}"
                  placeholder="{{ 'addressForm.selectOne' | cxTranslate }}"
                  id="region-select"
                  [cxNgSelectA11y]="{
                    ariaLabel: 'addressForm.state' | cxTranslate,
                  }"
                >
                </ng-select>
                <cx-form-errors [control]="addressForm.get('region.isocode')"></cx-form-errors>
              </label>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- City -->
      <div class="col-sm-12 col-md-4">
        <div class="form-group">
          <label>
            <span class="label-content required">
              {{ 'addressForm.city.label' | cxTranslate }}
              <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template>
            </span>

            <input
              required="true"
              type="text"
              class="form-control"
              placeholder="{{ 'addressForm.city.placeholder' | cxTranslate }}"
              formControlName="town"
              [maxlength]="40"
            />
            <cx-form-errors [control]="addressForm.get('town')"></cx-form-errors>
          </label>
        </div>
      </div>

      <!-- Address Line 1 -->
      <div class="col-12 col-md-4">
        <div class="form-group">
          <label>
            <span class="label-content required"
              >{{ 'addressForm.address1' | cxTranslate }} <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template
            ></span>
            <input
              required="true"
              type="text"
              class="form-control"
              placeholder="{{ 'addressForm.streetAddress' | cxTranslate }}"
              formControlName="line1"
              [maxlength]="40"
            />
            <cx-form-errors [control]="addressForm.get('line1')"></cx-form-errors>
          </label>
        </div>
      </div>

      <!-- Address Line 2 -->
      <div class="col-12 col-md-4">
        <div class="form-group">
          <label>
            <span class="label-content">{{ 'addressForm.address2' | cxTranslate }}</span>
            <input
              type="text"
              class="form-control"
              placeholder="{{ 'addressForm.aptSuite' | cxTranslate }}"
              formControlName="line2"
              [maxlength]="40"
            />
          </label>
        </div>
      </div>

      <!-- Complement -->
      <div class="col-12 col-md-4">
        <div class="form-group">
          <label>
            <span class="label-content">{{ 'addressForm.complement.label' | cxTranslate }} </span>

            <input
              class="form-control"
              type="text"
              name="complement"
              maxlength="10"
              placeholder="{{ 'addressForm.complement.placeholder' | cxTranslate }}"
              formControlName="complement"
              [maxlength]="40"
            />
            <cx-form-errors [control]="addressForm.get('complement')"></cx-form-errors>
          </label>
        </div>
      </div>

      <!-- ZipCode -->
      <div class="col-12 col-md-4">
        <div class="form-group">
          <label>
            <span class="label-content required"
              >{{ 'addressForm.zipCode.label' | cxTranslate }} <ng-template [ngTemplateOutlet]="requiredAsterisk"></ng-template
            ></span>
            <input
              required="true"
              type="text"
              class="form-control"
              placeholder="{{ 'addressForm.zipCode.placeholder' | cxTranslate }}"
              formControlName="postalCode"
              [maxlength]="40"
            />
            <cx-form-errors [control]="addressForm.get('postalCode')"></cx-form-errors>
          </label>
        </div>
      </div>

      <!-- Phone -->
      @if (this.country) {
        <div class="col-12 col-md-4">
          <div class="form-group">
            <label>
              <span class="label-content">{{ 'addressForm.phoneNumber.label' | cxTranslate }}</span>

              <div class="container-diallingCode">
                <span *ngIf="this.country.diallingCode" class="diallingCode">
                  {{ this.country.diallingCode }}
                </span>

                <input
                  type="tel"
                  class="form-control"
                  [mask]="country?.phoneMask || ''"
                  (keypress)="validateInput($event)"
                  placeholder="{{ 'addressForm.phoneNumber.placeholder' | cxTranslate }}"
                  formControlName="phone"
                />
              </div>

              <cx-form-errors [control]="addressForm.get('phone')"></cx-form-errors>
            </label>
          </div>
        </div>
      }
    </div>

    <div class="cx-address-form-btns p-0">
      <div class="row justify-content-between">
        <div class="col-12 col-lg-4 m-t-20" *ngIf="showCancelBtn">
          <button class="btn btn-block btn-outline-primary w-100" (click)="back()">
            {{ cancelBtnLabel || ('common.cancel' | cxTranslate) }}
          </button>
        </div>

        <div class="col-12 col-lg-4 w-100 m-t-20">
          <button #submit class="btn btn-block btn-primary w-100" type="submit">
            {{ actionBtnLabel || ('common.save' | cxTranslate) }}
          </button>
        </div>
      </div>
    </div>
  </form>

  <ng-template #requiredAsterisk>
    <abbr *cxFeature="'a11yRequiredAsterisks'" class="text-decoration-none" title="{{ 'common.required' | cxTranslate }}">*</abbr>
  </ng-template>
</ng-container>
